<main class="main-2-secton">
  <div class="">
    <div class="container-fluid">
      <div class="div-contents">
        <form action="" [formGroup]="csruploadForm">
          <div class="row corpate-main-section">
            <div class="col-lg-8 col-md-6 col-sm-12">
              <div class="incubator-detail-div ml-lg-4">
                <h3 style="color: #253b80">{{ projectView.projectName }}</h3>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 modal-btn">
              <button
                class="Approved-btn"
                *ngIf="getId.status == 0"
                (click)="ApprovedBtn(getId)"
              >
                Approve
              </button>
              <button
                class="reject-btn"
                *ngIf="getId.status == 0"
                (click)="RejectBtn(getId)"
              >
                Reject
              </button>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-card class="new-card">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                    <p class="sub-title">PROJECT DETAILS</p>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">Project Name : </span
                            ><span class="details-list">
                              {{ projectView.projectName }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">Sub Sector : </span
                            ><span class="details-list">
                              {{ projectView.projectSector }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head"
                              >Year of Completion : </span
                            ><span class="details-list">
                              {{ projectView.completionYear }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">Districts : </span
                            ><span class="details-list">
                              {{ projectView.districts }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">Taluks : </span
                            ><span class="details-list">
                              {{ projectView.taluks }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">Budget : </span
                            ><span class="details-list">
                              {{ projectView.budget }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head"
                              >Outcome Of Project : </span
                            ><span class="details-list">
                              {{ projectView.projectOutCome }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card>
            </div>
            <!-- ORGANIZATION DETAILS -->

            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-card class="new-card">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                    <p class="sub-title">ORGANIZATION DETAILS</p>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head"
                              >Organization Name : </span
                            ><span class="details-list">
                              {{ projectView.organizationName }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head"
                              >Year of Incorporation : </span
                            ><span class="details-list">
                              {{ projectView.inCropYear }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head"
                              >Darpan Registration Number : </span
                            ><span class="details-list">
                              {{ projectView.dropRegNo }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head"
                              >Registered address : </span
                            ><span class="details-list">
                              {{ projectView.regAddr }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card>
            </div>
            <!-- CEO/DIRECTOR NAME -->
            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-card class="new-card">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                    <p class="sub-title">CEO/DIRECTOR NAME</p>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">CEO Name : </span
                            ><span class="details-list">
                              {{ projectView.name }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">CEO Email : </span
                            ><span class="details-list">
                              {{ projectView.email }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">CEO Mobile : </span
                            ><span class="details-list">
                              {{ projectView.mobile }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card>
            </div>
            <!-- SPOC DETAILS -->
            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-card class="new-card">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                    <p class="sub-title">SPOC DETAILS</p>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">SPOC Name : </span
                            ><span class="details-list">
                              {{ projectView.spocName }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">SPOC Email : </span
                            ><span class="details-list">
                              {{ projectView.spocEmail }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="incubator-detail-div">
                      <div class="d-flex">
                        <div class="ml-3">
                          <p class="detail-p">
                            <span class="detail-side-head">SPOC Mobile : </span
                            ><span class="details-list">
                              {{ projectView.spocMobile }}</span
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card>
            </div>
            <!-- Document Details -->
            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-card class="new-card">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 title-head">
                    <p class="sub-title">Document Details</p>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-card class="doc-card">
                      <div class="incubator-detail-div">
                        <div class="d-flex align-items-center doc-card-cont">
                          <div class="ml-3">
                            <p class="detail-p">Incorparation Document</p>
                          </div>
                          <div class="ml-auto" (click)="incorpDocu()">
                            <div *ngIf="incorpFileName">
                              <img
                                src="assets\images\doc-download-image.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                            <div *ngIf="!incorpFileName">
                              <img
                                style="cursor: not-allowed"
                                src="assets\images\doc-download-cancel.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-card class="doc-card">
                      <div class="incubator-detail-div">
                        <div class="d-flex align-items-center doc-card-cont">
                          <div class="ml-3">
                            <p class="detail-p">12AA and 80G Document</p>
                          </div>
                          <div class="ml-auto" (click)="twlaa80gDoc()">
                            <div *ngIf="twlaaFileName">
                              <img
                                src="assets\images\doc-download-image.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                            <div *ngIf="!twlaaFileName">
                              <img
                                style="cursor: not-allowed"
                                src="assets\images\doc-download-cancel.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-card class="doc-card">
                      <div class="incubator-detail-div">
                        <div class="d-flex align-items-center doc-card-cont">
                          <div class="ml-3">
                            <p class="detail-p">Action plan of the project</p>
                          </div>
                          <div class="ml-auto" (click)="actionDocu()">
                            <div *ngIf="actionFileName">
                              <img
                                src="assets\images\doc-download-image.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                            <div *ngIf="!actionFileName">
                              <img
                                style="cursor: not-allowed"
                                src="assets\images\doc-download-cancel.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-card class="doc-card">
                      <div class="incubator-detail-div">
                        <div class="d-flex align-items-center doc-card-cont">
                          <div class="ml-3">
                            <p class="detail-p">Track Record Document</p>
                          </div>
                          <div class="ml-auto" (click)="trackrecDoc()">
                            <div *ngIf="trackFileName">
                              <img
                                src="assets\images\doc-download-image.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                            <div *ngIf="!trackFileName">
                              <img
                                style="cursor: not-allowed"
                                src="assets\images\doc-download-cancel.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card>
                  </div>
                  <div class="col-lg-4 col-md-6 col-sm-12">
                    <mat-card class="doc-card">
                      <div class="incubator-detail-div">
                        <div class="d-flex align-items-center doc-card-cont">
                          <div class="ml-3">
                            <p class="detail-p">Other Relevant Document</p>
                          </div>
                          <div class="ml-auto" (click)="otherrecDoc()">
                            <div *ngIf="otherFileName">
                              <img
                                src="assets\images\doc-download-image.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                            <div *ngIf="!otherFileName">
                              <img
                                style="cursor: not-allowed"
                                src="assets\images\doc-download-cancel.png"
                                alt="Image"
                                class="image-right"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card>
                  </div>
                </div>
              </mat-card>
            </div>
            <div class="col-lg-12 col-md-3 col-sm-12 col-12">
              <div class="text-center form-btn mt-5">
                <button
                  class="mr-2 btn new-btn-color1"
                  color="btn-success"
                  *ngIf="getId.status == 0"
                  (click)="ApprovedBtn(getId)"
                >
                  Approve
                </button>
                <button
                  class="mr-2 btn new-btn-color3"
                  color="btn-danger"
                  *ngIf="getId.status == 0"
                  (click)="RejectBtn(getId)"
                >
                  Reject
                </button>
                <button
                  class="mr-2 btn btn-warning new-btn-color2"
                  color="btn-warning"
                  (click)="cancelEvent()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</main>
